import styled from 'styled-components';

import ChatBubbleOutlineRoundedIcon from '@mui/icons-material/ChatBubbleOutlineRounded';
import FavoriteBorderRoundedIcon from '@mui/icons-material/FavoriteBorderRounded';

import ColormapInterface from 'shared-types/colormapinterface';
import { getSpacing, fontSize } from 'stylesheetB2b';

export const StyledControlBar = styled.div<{ colors: ColormapInterface }>`
  display: flex;
  justify-content: space-around;
  flex-shrink: 0;
  align-items: center;
  background-color: ${({ colors }) => colors.controlBarBackground};
  height: ${getSpacing(17)};
  border: none;
  padding: 0 ${getSpacing(4)};
`;
StyledControlBar.displayName = 'StyledControlBar';

export const ButtonContainer = styled.div`
  :not(:last-child) {
    margin-right: ${getSpacing(3)};
  }
`;
ButtonContainer.displayName = 'ButtonContainer';

export const ControlButtons = styled.div`
  margin-right: ${getSpacing(6)};
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;
ControlButtons.displayName = 'ControlButtons';

export const TimeSliderAndSongInfos = styled.div`
  flex: 1;

  /* setting a width here is necessary so that the container doesn't grow too much */
  width: 0;
  font-size: ${fontSize.large};
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 50%;
  padding-right: ${getSpacing(6.4)};
`;
TimeSliderAndSongInfos.displayName = 'TimeSliderAndSongInfos';

export const MessageIcon = styled(ChatBubbleOutlineRoundedIcon)``;
MessageIcon.displayName = 'Message';

export const FavoriteIcon = styled(FavoriteBorderRoundedIcon)`
  margin-right: ${getSpacing(5)};
`;
FavoriteIcon.displayName = 'Favorite';